import { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { OkrActivityI } from '~src/interfaces/okrActivity.interface';
import SimpleSearchInput from '~src/shared/form/inputs/SimpleSearchInput';
import SvgIcon from '~src/shared/SvgIcon';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { okrApi } from '~src/services/ApiController';
import { StoreI } from '~src/rootReducer';
import { getSystemLocale } from '~src/services/session';

import { ListHeader, ListTitle, SearchableWrapper } from './searchableActivityList.sc';
import ActivityList from './ActivityList';

interface OwnProps {
  initialActivities?: OkrActivityI[] | null;
  type: 'objective' | 'key_result';
  id: string;
}

interface StateProps {
  systemLanguage: string;
}

type Props = OwnProps & StateProps;

const SearchableActivityList: FC<Props> = props => {
  const [activities, setActivities] = useState(props.initialActivities || []);
  const [searchLoading, setSearchLoading] = useState(true);

  useEffect(() => {
    fetchActivities().finally(() => {
      setSearchLoading(false);
    });
  }, [props.id]);

  const fetchActivities = (q?: string) => {
    return okrApi
      .get(
        `activities/${q ? 'search/' : ''}${props.type}/${props.id}?lang=${props.systemLanguage}${
          q ? `&q=${q}` : ''
        }`,
      )
      .then(res => {
        setActivities(res.data);
        return res;
      });
  };

  const searchInActivities = async (val: string) => {
    setSearchLoading(true);
    await fetchActivities(val);
    setSearchLoading(false);
  };

  const [t] = useTranslation();

  return (
    <SearchableWrapper>
      <ListHeader>
        <ListTitle>
          <SvgIcon name="iconArrowClock" />
          <span data-translation="okr.activities.title">{t('okr.activities.title')}</span>
        </ListTitle>
        <SimpleSearchInput
          placeholder={{
            key: 'okr.activities.search.placeholder',
            value: t('okr.activities.search.placeholder'),
          }}
          onChange={searchInActivities}
        />
      </ListHeader>
      <>{searchLoading ? <LoadingSpinner /> : <ActivityList activities={activities} />}</>
    </SearchableWrapper>
  );
};

const mapStateToProps = (state: StoreI): StateProps => ({
  systemLanguage: getSystemLocale(state),
});

const SearchableActivityListConnected = connect(mapStateToProps)(SearchableActivityList);
export default SearchableActivityListConnected;
